import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "device-alarm",
  "use": "device-alarm-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"device-alarm\"><path d=\"M7 1h2v2H7V1zm4.5 8a3.5 3.5 0 1 0-7 0v3.5H7V9h2v3.5h2.5V9zM3 12.5V9a5 5 0 0 1 10 0v3.5h1V14H2v-1.5h1zM12 3h2v2h-2V3zM4 3H2v2h2V3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol